import { useState, useRef } from "react";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { Modal, Button } from "react-bootstrap";

const ImageCropModal = ({ show, imageSrc, onCancel, onCropComplete }) => {
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  const imgRef = useRef(null);

  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    const crop = centerCrop(
      makeAspectCrop({ unit: "%", width: 80 }, 1, width, height),
      width,
      height
    );
    setCrop(crop);
  };

  const getCroppedImage = () => {
    if (!completedCrop || !imgRef.current) return;
    const image = imgRef.current;
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = 300;
    canvas.height = 300;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(
      image,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0, 0, 300, 300
    );
    const base64 = canvas.toDataURL("image/jpeg", 0.7);
    onCropComplete(base64);
  };

  return (
    <Modal show={show} onHide={onCancel} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1rem" }}>Crop Photo (Square)</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        {imageSrc && (
          <ReactCrop
            crop={crop}
            onChange={(c) => setCrop(c)}
            onComplete={(c) => setCompletedCrop(c)}
            aspect={1}
            circularCrop={false}
          >
            <img
              ref={imgRef}
              src={imageSrc}
              onLoad={onImageLoad}
              style={{ maxWidth: "100%", maxHeight: "400px" }}
              alt="Crop"
            />
          </ReactCrop>
        )}
        <p className="text-muted mt-2" style={{ fontSize: "0.8rem" }}>
          Drag to adjust. The crop is square.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>Cancel</Button>
        <Button
          variant="primary"
          style={{ backgroundColor: "#ac2e62", border: "none" }}
          onClick={getCroppedImage}
        >
          Use This Photo
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImageCropModal;
